<h1>Templates Approvals</h1>
<app-config-approval repository="auto-deploy-templates" lambda="auto-deploy-templates" enableRollback="true"></app-config-approval>
